"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var KEYS_TO_SAVE = ['seenCompositorOnboarding', 'seenOnboarding', 'seenReadOnlyAlert', 'seenDraftSunset'];

function buildItemApiPath(namespace, key) {
  return "/gamera/v2/item/" + namespace + "/" + key;
}

function getGameraUrl(id) {
  return buildItemApiPath('content-compose', "user-settings-uid:" + id);
}

function getFavoriteBlogUrl(id) {
  return buildItemApiPath('blog', "user-settings-uid:" + id);
}

var SettingsManager = /*#__PURE__*/function () {
  function SettingsManager() {
    (0, _classCallCheck2.default)(this, SettingsManager);
  }

  (0, _createClass2.default)(SettingsManager, [{
    key: "fetch",
    value: function fetch(id) {
      return _apiClient.default.get(getGameraUrl(id)).then(function (data) {
        return JSON.parse(data.value);
      });
    }
  }, {
    key: "fetchFavoriteBlog",
    value: function fetchFavoriteBlog(id) {
      return _apiClient.default.get(getFavoriteBlogUrl(id)).then(function (data) {
        return JSON.parse(data.value);
      });
    }
  }, {
    key: "save",
    value: function save(id, data) {
      var toSave = KEYS_TO_SAVE.reduce(function (acc, cur) {
        acc[cur] = data[cur];
        return acc;
      }, {});
      return _apiClient.default.put(getGameraUrl(id), {
        data: toSave
      });
    }
  }]);
  return SettingsManager;
}();

exports.default = SettingsManager;
module.exports = exports.default;